import { isSameDay } from 'date-fns';
import type { FormatIntlParams } from '../types';
import type { ResolvedFormatIntlType } from './get-formatter';

type P = FormatIntlParams;

export const resolveFormatIntlType = (params: P): ResolvedFormatIntlType => {
  if (params.type === 'relativeDateTime') {
    const compareDate = params.compareDate ? new Date(params.compareDate) : new Date();

    return isSameDay(compareDate, new Date(params.start)) ? 'time' : 'dateTime';
  }

  return params.type;
};
